<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-6">
                            <h3 class="breadcrumb-title m-0 pe-3"> Search Results </h3>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <section class="inner-section-wrap" *ngIf="searchList.length !=0">
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3">

                        <!-- start Coulam -->
                        <div class="col pb-4">

                            <div class="card dark-bg video-card2 overlapping-card border-radius10">
                                <a routerLink="/video-detail" class="d-block">
                                    <div class="card-video2-box imgvid-cover border-radius10">
                                        <img  loading="lazy"  class="border-radius10" src="../../../assets/images/img05.png" />
                                    </div>
                                    <!-- <div class="card-edit-ic">
                            <a href="javascript:void(0):"> <i class="fa-solid fa-pencil"></i> </a>
                        </div> -->
                                    <div class="card-content overlapping-card-content p-3">
                                        <div class="video-category pb-3">
                                            <div class="brand-badge p-3 border-radius10 d-inline-block"> Mark Smith </div>
                                        </div>
                                        <h5 class="title m-0 white-color py-3"> Pulling away from people and usual activities... </h5>

                                        <div class="card-footer p-0 m-0 border-0">
                                            <div class="row align-items-center">
                                                <!-- <div class="col-5">
                                        <div class="video-duration d-flex align-items-center">
                                            <i class="fa-solid fa-clock greenlight-color font-16"></i>
                                            <span class="ps-1 font-11"> 20 Min </span>
                                        </div>
                                    </div> -->
                                                <div class="col-12">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                        <div class="video-view d-flex align-items-center pe-3">
                                                            <i class="gricon gr_ic_eye brandsecundary-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> 11,124 </span>
                                                        </div>
                                                        <div class="video-like d-flex align-items-center">
                                                            <i class="gricon gr_ic_heart orange-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> 8,150 </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </a>
                            </div>
                        </div>
                        <!-- End Coulam -->

                        <!-- start Coulam -->
                        <div class="col pb-4">

                            <div class="card dark-bg video-card2 overlapping-card border-radius10">
                                <a routerLink="/video-detail" class="d-block">
                                    <div class="card-video2-box imgvid-cover border-radius10">
                                        <img  loading="lazy"  class="border-radius10" src="../../../assets/images/img06.png" />
                                    </div>
                                    <!-- <div class="card-edit-ic">
                            <a href="javascript:void(0):"> <i class="fa-solid fa-pencil"></i> </a>
                        </div> -->
                                    <div class="card-content overlapping-card-content p-3">
                                        <div class="video-category pb-3">
                                            <div class="brand-badge p-3 border-radius10 d-inline-block"> Mark Smith </div>
                                        </div>
                                        <h5 class="title m-0 white-color py-3"> Experiencing severe mood swings that cause problems in life... </h5>

                                        <div class="card-footer p-0 m-0 border-0">
                                            <div class="row align-items-center">
                                                <!-- <div class="col-5">
                                        <div class="video-duration d-flex align-items-center">
                                            <i class="fa-solid fa-clock greenlight-color font-16"></i>
                                            <span class="ps-1 font-11"> 20 Min </span>
                                        </div>
                                    </div> -->
                                                <div class="col-12">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                        <div class="video-view d-flex align-items-center pe-3">
                                                            <i class="gricon gr_ic_eye brandsecundary-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> 11,124 </span>
                                                        </div>
                                                        <div class="video-like d-flex align-items-center">
                                                            <i class="gricon gr_ic_heart orange-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> 8,150 </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </a>
                            </div>
                        </div>

                        <!-- start Coulam -->
                        <div class="col pb-4">

                            <div class="card dark-bg video-card2 overlapping-card border-radius10">
                                <a routerLink="/video-detail" class="d-block">
                                    <div class="card-video2-box imgvid-cover border-radius10">
                                        <img  loading="lazy"  class="border-radius10" src="../../../assets/images/img07.png" />
                                    </div>
                                    <!-- <div class="card-edit-ic">
                                <a href="javascript:void(0):"> <i class="fa-solid fa-pencil"></i> </a>
                            </div> -->
                                    <div class="card-content overlapping-card-content p-3">
                                        <div class="video-category pb-3">
                                            <div class="brand-badge p-3 border-radius10 d-inline-block"> Mark Smith </div>
                                        </div>
                                        <h5 class="title m-0 white-color py-3"> Pulling away from people and usual activities... </h5>

                                        <div class="card-footer p-0 m-0 border-0">
                                            <div class="row align-items-center">
                                                <!-- <div class="col-5">
                                        <div class="video-duration d-flex align-items-center">
                                            <i class="fa-solid fa-clock greenlight-color font-16"></i>
                                            <span class="ps-1 font-11"> 20 Min </span>
                                        </div>
                                    </div> -->
                                                <div class="col-12">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                        <div class="video-view d-flex align-items-center pe-3">
                                                            <i class="gricon gr_ic_eye brandsecundary-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> 11,124 </span>
                                                        </div>
                                                        <div class="video-like d-flex align-items-center">
                                                            <i class="gricon gr_ic_heart orange-color font-16"></i>
                                                            <span class="ps-1 font-11 white-color"> 8,150 </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </a>
                            </div>
                        </div>
                        <!-- End Coulam -->

                    </div>
                </section>






                <!-- Section Wrap Start -->
                <section class="inner-section-wrap py-5" *ngIf="searchList.length ==0">
                    <div class="container">
                        <!-- Search Not Found Start -->
                        <div class="search-not-found">
                            <div class="img-box imgvid-contain py-5">
                                <img  loading="lazy"  class="border-radius10" src="assets/images/search_not_found.png">
                            </div>
                            <div class="search-not-found-content text-center pt-5">
                                <h4 class="title light-color">Sorry, we couldn’t find any results for this search.</h4>
                                <p> Maybe give one of these a try? </p>
                            </div>
                            <!-- Search Block Start -->
                            <div class="search-block pb-4 border-0">
                                <div class="row align-items-center justify-content-center">
                                    <div class="col-12 col-sm-6 col-lg-4 pt-5">
                                        <div class="search-border-box">
                                            <input placeholder="{{ 'GREATER.SEARCH' | translate }}..." class="form-search-input" type="text" [(ngModel)]="search" (change)="searchText()">
                                            <button type="submit" class="search-btn"> <i class="gricon gr_ic_search_full"></i> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Search Block End -->
                        </div>
                        <!-- Search Not Found End -->
                    </div>
                </section>
                <!-- Section Wrap End -->



            </div>
        </div>
        <!--end page wrapper -->

    </div>
    <app-footer></app-footer>
</main>